const mixin = {
  methods: {
    getMessage(message) {
      switch (message) {
        case "Invalid identifier or password":
          return "Usuário e/ou senha inválidos."
        case "Your account email is not confirmed":
          return "A sua conta não foi confirmada. Verifique seu email."
        case "Email or Username are already taken":
          return "Email já registrado."
        case "Incorrect code provided":
          return "Solicitaçõa não atendida, verifique seu email ou inicie o processo de recuperação novamente."
        case "capacidade must be a `number` type, but the final value was: `NaN`.":
          return "A capacidade mínima de uma sala é 1"
        default:
          return message
      }
    },
  },
}

export default mixin
